import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CognitoService } from 'src/app/modules/shared/services/cognito.service';
import { fetchAuthSession } from 'aws-amplify/auth';

export const authGuard: CanActivateFn = async () => {
  const cognitoService = inject(CognitoService);
  const router = inject(Router);

  // If Amplify is processing an OAuth callback (?code= in URL), wait for it to finish
  if (window.location.search.includes('code=') || window.location.href.includes('?code=')) {
    try {
      await fetchAuthSession();
      return true;
    } catch {
      // callback processing failed — fall through to login
    }
  }

  try {
    await cognitoService.currentAuthenticatedUser();
    return true;
  } catch {
    router.navigate(['/login']);
    return false;
  }
};
